import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGreyhounds = (props) => /* @__PURE__ */ _jsx("svg", {
	"data-name": "Icon - Greyhounds",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 23.541 24.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		"data-name": "Group 661",
		children: [
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 3947",
				d: "M9.318,6.5a4.688,4.688,0,0,1-3.247,4.326c-1.995.186-3.145-1.127-1.87-4.96C4.98,3.527,5.717.75,10.592.75A5.7,5.7,0,0,1,15.7,4.583L22.766,5.86s.93,6.39-8.341,5.277c-1.277,5.114,0,10.062-3.833,12.613C2.579,23.75.75,18.493.75,18.493c1.793-1.217,5.321-4.253,5.321-7.671",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 3948",
				d: "M12.425,5.423a.25.25,0,0,1,.25.25",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 3949",
				d: "M12.171,5.671a.25.25,0,0,1,.25-.248",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 3950",
				d: "M12.425,5.923a.251.251,0,0,1-.178-.073.245.245,0,0,1-.072-.177",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				"data-name": "Path 3951",
				d: "M12.671,5.671a.248.248,0,0,1-.248.25h0",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	})
});
export { SvgIconGreyhounds as ReactComponent };
